import { useIsFeatureEnabled } from "@fero/hooks";
import { NewOrganisationPurchaseRequestSetupPage } from "./new-organisation-purchase-request-setup-page";
import { OrganisationPurchaseRequestSetupPage as OldOrganisationPurchaseRequestSetupPage } from "./organisation-purchase-request-setup-page";

/**
 * Super lightweight component to determine with page to render for the Organisation Purchase Request Setup page
 * The reason we need this is that in the main app.tsx component, we don't have access to the selected entity context yet
 * and due to this when the selected entity changes context does not rerender the component
 */
export const OrganisationTradeSaleSetupPage = () => {
  const showNewTradeSalesScreen = useIsFeatureEnabled("new_trade_sales_ui");

  if (showNewTradeSalesScreen) {
    return <NewOrganisationPurchaseRequestSetupPage />;
  }
  return <OldOrganisationPurchaseRequestSetupPage />;
};
